module.exports = (root) => {
    const base = root.querySelector('[data-sync-position-base]');
    const elems = [...root.querySelectorAll('[data-sync-position-item]')];
    const parents = elems.map(el => el.parentNode.parentNode);

    return {
        invalidate() {
            const bounds = base.getBoundingClientRect();
            const x1 = bounds.left;
            elems.forEach((el, i) => {
                const bnds = parents[i].getBoundingClientRect();
                el.style.transform = `translate3d(${x1 - bnds.left}px, 0, 0)`;
            });
        },
        clear() {
            elems.forEach(el => {
                el.style.transform = '';
            });
        }
    };
};
